import { render, staticRenderFns } from "./ModattaUploadImage.vue?vue&type=template&id=1067f971"
import script from "./ModattaUploadImage.vue?vue&type=script&lang=js"
export * from "./ModattaUploadImage.vue?vue&type=script&lang=js"
import style0 from "./ModattaUploadImage.vue?vue&type=style&index=0&id=1067f971&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports